import styled from 'styled-components';

const BarContainer = styled.div`
  flex: 1;
  height: 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.mainColorContrastDarker};
`;

const Bar = styled.div`
  height: 100%;
  width: ${({ progress }) => (progress > 100 ? 100 : progress)}%;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.mainColor};
  transition: 0.1s;
`;

export {
  Bar,
  BarContainer,
};
